class DeleteConfirmationForm extends ViewBasic {
    constructor(options) {
        super(options);

        this.$deleteBtn = this.$('.btn-submit');
        this.$btnClose = this.$('.btn-close');



        // this.fields = [
        //     {name: 'id'}
        // ]

        this.addEvents();
    }

    addEvents() {
        Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        Me.dispatch.subscribe('Application.getID',  (e, params)=> this.fillApplicationID(e, params));
        this.$deleteBtn.on('click', (e) => this.deleteApplication(e));
        this.$btnClose.on('click', (e)=> this.closeHandler(e));
    }

    removeEvents() {
        Me.dispatch.unsubscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
        Me.dispatch.unsubscribe('Application.getID',  (e, params)=> this.fillApplicationID(e, params));
        this.$deleteBtn.off('click', (e) => this.deleteApplication(e));
        this.$btnClose.off('click', (e)=> this.closeHandler(e));
    }

    fillApplicationID(e, params){
        this.$el.attr('data-id', params.applicationId);
    }

    deleteApplication(e){
        // Delete application
        $.ajax({
            type: this.$el.attr('method'),
            url: this.$el.attr('action'),
            data: {
                id: this.$el.attr('data-id')
            },
            success: $.proxy(this.ajaxSuccess, this),
            error: $.proxy(this.ajaxError, this)
        });

        this.$deleteBtn.addClass('loading');
    }

    closeHandler(e){
        e.preventDefault();
        Me.dispatch.emit('close-modal', this, {name: this.name});
    }

    ajaxSuccess(){
        this.$deleteBtn.removeClass('loading').addClass('loading-complete');
        window.location.reload();
    }

    ajaxError(){
    }

    handleBreakpoints(e, params) {

    }
}

